export default __webpack_public_path__ + "static/media/1.73d9d2b8.jpg";